<div [@routerTransition]>
    <sub-header [title]="'SalesInvoices' | localize" >
        <div role="actions">
            <div class="btn-group" dropdown placement="button right">
                <button id="dropdownButtonExcelOperations"
                        dropdownToggle
                        type="button"
                        class="btn btn-outline btn-outline-success btn-active-light-success dropdown-toggle me-1"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        aria-controls="dropdownMenuExcelOperations">
                    <i class="far fa-file-excel btn-md-icon"></i>
                    <span class="d-none d-md-inline-block">
                        {{ 'ExcelOperations' | localize }}
                    </span>
                </button>
                <ul id="dropdownMenuExcelOperations"
                    class="dropdown-menu dropdown-menu-right dropdown-excel-operations"
                    role="menu"
                    *dropdownMenu
                    aria-labelledby="dropdownButtonExcelOperations">
                    <li role="menuitem">
                        <a class="dropdown-item text-gray-900"
                           id="ExportSalesOrdersToExcelButton"
                           (click)="this.showExcelColumnSelectionModal()"
                           href="javascript:;">
                            <i class="fa fa-download me-2 mt-1 text-gray-900" style="font-size: 1rem"></i>
                            {{ 'ExportToExcel' | localize }}
                        </a>
                    </li>

                    <li *ngIf="'Pages.SalesInvoice.Create' | permission" role="menuitem">
                        <a href="javascript:;" class="no-padding">
                            <span class="fileinput-button">
                                <p-fileUpload mode="basic"
                                              customUpload="true"
                                              name="ExcelFileUpload"
                                              #ExcelFileUpload
                                              maxFileSize="10000000"
                                              auto="auto"
                                              accept=".csv,.xls,.xlsx"
                                              (uploadHandler)="uploadExcel($event)"
                                              (onError)="onUploadExcelError()"
                                              chooseLabel="{{ 'ImportFromExcel' | localize }}"></p-fileUpload>
                            </span>
                        </a>
                    </li>
                </ul>
            </div>

            <button id="btn_create_salesInvoice"
                    *ngIf="'Pages.SalesInvoice.Create' | permission"
                    (click)="createSalesInvoice()"
                    class="btn btn-primary blue">
                <i class="fa fa-plus"></i>
                {{ l('CreateNewSalesInvoice') }}
            </button>
        </div>
    </sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <form>
                    <div>
                        <div class="row">
                            <div class="col-md-3">
                                <select name="customerId" [(ngModel)]="customerId"
                                            (change)="getsalesInvoices($event)"
                                            class="form-select">
                                        <option value="0">{{ l('SelectACustomer') }}</option>

                                        <option *ngFor="let item of allCustomers" value="{{ item.id }}">
                                            {{ item.displayName }}
                                        </option>
                                    </select>

                            </div>
                            <div class="col-md-3">
                                    <div class="input-group mb-3">
                                        <input [(ngModel)]="sNo"
                                                name="sNo"
                                                autoFocus
                                                type="text"
                                                class="form-control"
                                                [placeholder]="l('InvoiceNo')" />
                                    </div>
                            </div>
                            <div class="col-md-3">
                                    <div class="input-group mb-3">
                                        <input [(ngModel)]="referenceNo"
                                                name="referenceNo"
                                                autoFocus
                                                type="text"
                                                class="form-control"
                                                [placeholder]="l('ReferenceNo')" />
                                    </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <label class="form-check form-check-custom form-check-solid">
                                    <input id="DateRange"
                                           #Product_IsActive="ngModel"
                                           name="DateRange"
                                           [(ngModel)]="dateRangeSelected"
                                           (click)="OnselectDateRange($event)"
                                           type="checkbox"
                                           class="form-check-input" />
                                    <span class="form-check-label">
                                        {{ l('DateRange') }}
                                    </span>
                                </label>
                            </div>
                            <div class="col-md-3" *ngIf="dateRangeSelected">
                                    <p-calendar [(ngModel)]="dateRange"
                                                selectionMode="range"
                                                dateFormat="yy-mm-dd"
                                                inputStyleClass="form-control">
                                    </p-calendar>
                            </div>
                            <div class="col-md-3">
                                        <select name="vendorId" [(ngModel)]="invoiceStatus"
                                                (change)="getsalesInvoices($event)"
                                                class="form-select">
                                            <option value="0">{{ l('All') }}</option>

                                            <option *ngFor="let item of allStatus" value="{{ item.id }}">
                                                {{ item.displayName }}
                                            </option>
                                        </select>
                            </div>
                            <div class="col-md-3">
                                    <button class="btn btn-default btn-primary blue btn-sm" type="submit" (click)="getsalesInvoices($event)">
                                        Refresh
                                    </button>
                                    &nbsp;&nbsp;&nbsp;
                                    <button id="btn-reset-filters" class="btn btn-secondary btn-sm" (click)="getsalesInvoices($event)"> Reset </button>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="row align-items-center">
                    <!--<Primeng-Datatable-Start>-->
                    <div class="primeng-datatable-container col-12" [busyIf]="primengTableHelper.isLoading">
                        <p-table #dataTable
                                 (onLazyLoad)="getsalesInvoices($event)"
                                 [value]="primengTableHelper.records"
                                 rows="{{ primengTableHelper.defaultRecordsCountPerPage }}"
                                 [paginator]="false"
                                 tableStyleClass="table table-bordered table-hover"
                                 [lazy]="true"
                                 [scrollable]="true"
                                 ScrollWidth="100%"
                                 [tableStyle]="{ 'min-width': '50rem' }"
                                 [resizableColumns]="primengTableHelper.resizableColumns">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width: 5%"
                                        [hidden]="
                                            !isGrantedAny('Pages.SalesInvoice.Edit', 'Pages.SalesInvoice.Delete')
                                        ">
                                        {{ l('Actions') }}
                                    </th>
                                    <th style="width: 150px" pSortableColumn="pNo">
                                        {{ l('InvoiceNo') }}
                                        <p-sortIcon field="salesInvoice.pNo"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="pDate">
                                        {{ l('PDate') }}
                                        <p-sortIcon field="salesInvoice.pDate"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="vendorFk.displayProperty">
                                        {{ l('Customer') }}
                                        <p-sortIcon field="vendorDisplayProperty"></p-sortIcon>
                                    </th>

                                    <th style="width: 150px" pSortableColumn="referenceNo">
                                        {{ l('ReferenceNo') }}
                                        <p-sortIcon field="salesInvoice.referenceNo"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="subTotal">
                                        {{ l('PSubTotal') }}
                                        <p-sortIcon field="salesInvoice.subTotal"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="tax">
                                        {{ l('PTax') }}
                                        <p-sortIcon field="salesInvoice.tax"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="netTotal">
                                        {{ l('PNetTotal') }}
                                        <p-sortIcon field="salesInvoice.netTotal"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="grandTotal">
                                        {{ l('PGrandTotal') }}
                                        <p-sortIcon field="salesInvoice.grandTotal"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="status">
                                        <b>{{ l('Status') }}</b>
                                        <p-sortIcon field="salesInvoice.status"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="status">
                                        <b>{{ l('PaymentStatus') }}</b>
                                        <p-sortIcon field="salesInvoice.status"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="creationTime">
                                        {{ l('CreationTime') }}
                                        <p-sortIcon field="salesInvoice.creationTime"></p-sortIcon>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-record="$implicit" let-i="rowIndex">
                                <tr>
                                    <td style="width: 5%"
                                        [hidden]="
                                            !isGrantedAny('Pages.SalesInvoice.Edit', 'Pages.SalesInvoice.Delete')
                                        ">
                                        <div class="btn-group dropdown" dropdown container="body">
                                            <button class="dropdown-toggle btn btn-sm btn-primary" dropdownToggle>
                                                <i class="fa fa-cog"></i>
                                                <span class="caret"></span>
                                            </button>
                                            <ul class="dropdown-menu" *dropdownMenu>
                                                <li>
                                                    <a *ngIf="permission.isGranted('Pages.SalesInvoice.Edit') && record.sales.status == status.Invoiced"
                                                       class="dropdown-item"
                                                       [routerLink]="[
                                                            '/app/sales/salesInvoices/createOrEdit',
                                                        ]"
                                                       [queryParams]="{ id: record.sales.id }">
                                                        {{ l('View') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a *ngIf="permission.isGranted('Pages.SalesInvoice.Edit') && record.sales.status == 1"
                                                       class="dropdown-item"
                                                       [routerLink]="[
                                                            '/app/sales/salesInvoices/createOrEdit',
                                                        ]"
                                                       [queryParams]="{ id: record.sales.id }">
                                                        {{ l('Edit') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       *ngIf="permission.isGranted('Pages.SalesInvoice.Draft') && record.sales.status == status.Invoiced && record.sales.paymentStatus == paymentStatus.UnPaid"
                                                       (click)="convertToDraft(record.sales)">
                                                        {{ l('ConvertToDraft') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       *ngIf="permission.isGranted('Pages.SalesInvoice.Invoiced') && record.sales.status == status.Draft && record.sales.paymentStatus == paymentStatus.UnPaid"
                                                       (click)="convertToInvoiced(record.sales)">
                                                        {{ l('ConvertToInvoiced') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a *ngIf="record.sales.paymentStatus == paymentStatus.UnPaid"
                                                       class="dropdown-item"
                                                       [routerLink]="[
                                                            '/app/sales/customerPayments/createOrEdit',
                                                        ]"
                                                       [queryParams]="{ cid: record.sales.customerId, invid: record.sales.id }">
                                                        {{ l('Pay') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       *ngIf="permission.isGranted('Pages.SalesInvoice.Delete') &&  record.sales.paymentStatus == paymentStatus.UnPaid"
                                                       (click)="deleteSalesInvoice(record.sales)">
                                                        {{ l('Delete') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       (click)="print(record.sales.id)">
                                                        {{ l('Print') }}
                                                    </a>
                                                </li>
                                                <li *ngIf="record.sales.journalHeaderId">
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       (click)="printVoucher(record.sales.journalHeaderId)">
                                                        {{ l('PrintVoucher') }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('PNo') }}</span>
                                        {{ record.sales.pNo }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('PDate') }}</span>

                                        <span *ngIf="record.sales.date">
                                            {{ record.sales.date | luxonFormat: "dd-LLL-yyyy" }}
                                        </span>
                                        <span *ngIf="!record.sales.date">-</span>
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{l('{{Property_Name_Here}}')}}</span>
                                        {{ record.customerDisplayProperty }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('ReferenceNo') }}</span>
                                        {{ record.sales.referenceNo }}
                                    </td>
                                    <td style="width: 150px" class="text-end">
                                        <span class="p-column-title">{{ l('PSubTotal') }}</span>
                                        {{ record.sales.subTotal | priceFormat }}
                                    </td>
                                    <td style="width: 150px" class="text-end">
                                        <span class="p-column-title">{{ l('PTax') }}</span>
                                        {{ record.sales.tax | priceFormat  }}
                                    </td>
                                    <td style="width: 150px" class="text-end">
                                        <span class="p-column-title">{{ l('PNetTotal') }}</span>
                                        {{ record.sales.netTotal | priceFormat  }}
                                    </td>
                                    <td style="width: 150px" class="text-end">
                                        <span class="p-column-title">{{ l('PGrandTotal') }}</span>
                                        {{ record.sales.grandTotal | priceFormat  }}
                                    </td>
                                    <td style="width: 150px" class="text-center">
                                        <span class="p-column-title">{{ l('Status') }}</span>
                                        <span class="badge" [ngClass]="utilsService.getStatusBadgeClass(record.sales.status)">
                                            {{ l(status[record.sales.status]) }}
                                        </span>
                                    </td>
                                    <td style="width: 150px" class="text-center">
                                        <span class="p-column-title">{{ l('PaymentStatus') }}</span>
                                        <span class="badge" [ngClass]="utilsService.getPaymentStatusBadgeClass(record.sales.paymentStatus)">
                                            {{ l(paymentStatus[record.sales.paymentStatus]) }}
                                        </span>
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('CreationTime') }}</span>

                                        <span *ngIf="record.sales.creationTime">
                                            {{ record.sales.creationTime | luxonFormat: "dd-LLL-yyyy HH:mm" }}
                                        </span>
                                        <span *ngIf="!record.sales.creationTime">-</span>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>

                        <div class="primeng-no-data" *ngIf="primengTableHelper.totalRecordsCount == 0">
                            {{ l('NoData') }}
                        </div>

                        <div class="primeng-paging-container">
                            <p-paginator [rows]="primengTableHelper.defaultRecordsCountPerPage"
                                         #paginator
                                         (onPageChange)="getsalesInvoices($event)"
                                         [totalRecords]="primengTableHelper.totalRecordsCount"
                                         [rowsPerPageOptions]="primengTableHelper.predefinedRecordsCountPerPage"
                                         [showCurrentPageReport]="true"
                                         [currentPageReportTemplate]="
                                    'TotalRecordsCount' | localize: primengTableHelper.totalRecordsCount
                                "></p-paginator>
                        </div>
                    </div>
                    <!--<Primeng-Datatable-End>-->
                </div>
            </div>
        </div>
    </div>

    <excel-column-selection-modal (modalSave)="exportToExcel($event)"
                                  #excelColumnSelectionModal></excel-column-selection-modal>
</div>
